module.exports = __webpack_public_path__ + "img/questionnaire.5af0693c.png";